import React from "react"
import { Stack } from "@carrotfertility/carotene"
import { HomepageHelp } from "./components/homepage/HomepageHelp"
import { ProviderSearchForm } from "./components/homepage/ProviderSearchForm"
import { Benefit } from "./types/Benefit"
import { Helmet } from "react-helmet"
import { useIntl } from "react-intl"

export function ProviderHomepage({ benefit }: { benefit: Benefit }): JSX.Element {
  const intl = useIntl()
  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            defaultMessage: "Find a provider | Carrot Fertility",
            description: "The title of the current page as shown in the browser's tab or window."
          })}
        </title>
      </Helmet>
      <Stack direction="column" spacing="huge" padding="24px 0 16px 0">
        <ProviderSearchForm benefit={benefit} />
        <HomepageHelp />
      </Stack>
    </>
  )
}
